import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const AssetLevelEditToggle = ({ company, subcompany, asset_level, t }) => (
  <Form.Link
    className="btn btn-outline-primary btn-sm mx-2"
    to={createRoute(company.id, subcompany.id, `asset_level/${asset_level.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(AssetLevelEditToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/actions/AssetLevelActionsEdit.js